import React from "react";
import { Navigate, Route } from "react-router";
import { all_routes } from "./all_routes";
import ComingSoon from "../pages/comingSoon";
import Login from "../auth/login/login";
import LandingPage from "../landing/LandingPage";
import Error404 from "../pages/error/error-404";
import Error500 from "../pages/error/error-500";
import UnderMaintenance from "../pages/underMaintenance";
import DashboardRouter from "../dashboard";

import ResetPassword2 from "../auth/resetPassword/resetPassword-2";
import ForgotPassword2 from "../auth/forgotPassword/forgotPassword-2";
import ResetPasswordSuccess from "../auth/resetPasswordSuccess/resetPasswordSuccess";
import ResetPasswordSuccess2 from "../auth/resetPasswordSuccess/resetPasswordSuccess-2";
import ResetPasswordSuccess3 from "../auth/resetPasswordSuccess/resetPasswordSuccess-3";

import LockScreen from "../auth/lockScreen";
import KanbanView from "../application/kanbanView";
import UnderConstruction from "../pages/underConstruction";
import PrivacyPolicy from "../pages/privacy-policy";
import Tickets from "../tickets/tickets";
import EmployeesGrid from "../hrm/employees/employeesGrid";
import TaskDetails from "../projects/task/taskdetails";
import ProtectedRoute from "./ProtectedRoute";
import OrganisationsList from "../owner/organisations/index";
import OrgMasters from "../org/masters/index";
import OrgUsers from "../org/users/index";
import OrgRoles from "../org/roles/index";
import OrgExternalUpdates from "../org/external-updates/index";

const routes = all_routes;

const withAuth = (element: React.ReactElement) => <ProtectedRoute>{element}</ProtectedRoute>;

export const publicRoutes = [
  {
    path: routes.adminDashboard,
    element: withAuth(<DashboardRouter />),
    route: Route,
  },
  {
    path: routes.kanbanView,
    element: withAuth(<KanbanView />),
    route: Route,
  },
  {
    path: routes.employeeGrid,
    element: withAuth(<EmployeesGrid />),
    route: Route,
  },
  {
    path: routes.tickets,
    element: withAuth(<Tickets />),
    route: Route,
  },
  {
    path: routes.tasksdetails,
    element: withAuth(<TaskDetails />),
    route: Route,
  },
  {
    path: "/owner/organisations",
    element: withAuth(<OrganisationsList />),
    route: Route,
  },
  {
    path: "/programs",
    element: <Navigate to="/org-masters" replace />,
    route: Route,
  },
  {
    path: "/org-masters",
    element: withAuth(<OrgMasters />),
    route: Route,
  },
  {
    path: "/org-users",
    element: withAuth(<OrgUsers />),
    route: Route,
  },
  {
    path: "/org-roles",
    element: withAuth(<OrgRoles />),
    route: Route,
  },
  {
    path: "/org-external-updates",
    element: withAuth(<OrgExternalUpdates />),
    route: Route,
  },
];

export const authRoutes = [
  {
    path: "/",
    element: <LandingPage />,
    route: Route,
  },
  {
    path: routes.privacyPolicy,
    element: <PrivacyPolicy />,
  },
  {
    path: routes.comingSoon,
    element: <ComingSoon />,
    route: Route,
  },
  {
    path: routes.login,
    element: <Login />,
    route: Route,
  },
  {
    path: routes.resetPassword2,
    element: <ResetPassword2 />,
    route: Route,
  },
  {
    path: routes.forgotPassword2,
    element: <ForgotPassword2 />,
    route: Route,
  },
  {
    path: routes.error404,
    element: <Error404 />,
    route: Route,
  },
  {
    path: routes.error500,
    element: <Error500 />,
    route: Route,
  },
  {
    path: routes.underMaintenance,
    element: <UnderMaintenance />,
    route: Route,
  },
  {
    path: routes.underConstruction,
    element: <UnderConstruction />,
  },
  {
    path: routes.lockScreen,
    element: <LockScreen />,
  },
  {
    path: routes.resetPasswordSuccess,
    element: <ResetPasswordSuccess />,
  },
  {
    path: routes.resetPasswordSuccess2,
    element: <ResetPasswordSuccess2 />,
  },
  {
    path: routes.resetPasswordSuccess3,
    element: <ResetPasswordSuccess3 />,
  },
];
